/** Ticket list row state (Freshservice-style). */

export const TERMINAL_TICKET_STATUSES = ['Completed', 'Rejected', 'Voided', 'Resolved', 'Closed'];

export const TICKET_STATE_STYLES = {
  new: {
    label: 'New',
    bg: '#DCFCE7',
    color: '#166534',
  },
  requester_respond: {
    label: 'Requester Respond',
    bg: '#DBEAFE',
    color: '#1D4ED8',
  },
  response_due: {
    label: 'Response Due',
    bg: '#FCE7F3',
    color: '#BE185D',
  },
  overdue: {
    label: 'Overdue',
    bg: '#FEE2E2',
    color: '#B91C1C',
  },
};

export function isTerminalTicketStatus(status) {
  return TERMINAL_TICKET_STATUSES.includes(status);
}

function hasAgentFirstResponse(t) {
  return !!(t.first_response_at || t.firstResponseAt);
}

function firstResponseDueMs(t) {
  const raw = t.firstResponseDueAt || t.first_response_due_at;
  if (!raw) return null;
  const ms = new Date(raw).getTime();
  return Number.isNaN(ms) ? null : ms;
}

function isFirstResponseOverdue(t) {
  if (hasAgentFirstResponse(t)) return false;
  const dueMs = firstResponseDueMs(t);
  return dueMs != null && dueMs < Date.now();
}

function isResolutionOverdue(t) {
  if (isTerminalTicketStatus(t.status)) return false;
  if (t.slaStatus === 'breached') return true;
  const raw = t.resolutionDueAt || t.resolution_due_at || t.due_by;
  if (!raw) return false;
  const dueMs = new Date(raw).getTime();
  if (Number.isNaN(dueMs)) return false;
  return dueMs < Date.now();
}

function isResponseDue(t) {
  if (hasAgentFirstResponse(t) || isFirstResponseOverdue(t)) return false;
  const dueMs = firstResponseDueMs(t);
  if (dueMs == null) return false;
  const now = Date.now();
  const remain = dueMs - now;
  if (remain <= 0) return false;
  const createdRaw = t._created_at;
  const createdMs = createdRaw ? new Date(createdRaw).getTime() : dueMs - 86400000;
  const total = dueMs - createdMs;
  if (total <= 0) return t.slaStatus === 'at_risk';
  return remain / total < 0.2 || t.slaStatus === 'at_risk';
}

function isLastMessageFromRequester(t) {
  const mode = t.latestConversationMode || t.latest_conversation_mode;
  if (mode === 'requester_reply') return true;
  if (t.latestConversationFromEmail || t.latest_conversation_from_email) return true;
  const senderId = t.latestConversationSenderId ?? t.latest_conversation_sender_id;
  if (senderId != null && senderId !== '') return false;
  const senderEmail = String(
    t.latestConversationSenderEmail || t.latest_conversation_sender_email || ''
  ).toLowerCase().trim();
  const reqEmail = String(t.email || t.requester_email || '').toLowerCase().trim();
  if (senderEmail && reqEmail && senderEmail === reqEmail) return true;
  return false;
}

/**
 * @returns {'new'|'requester_respond'|'response_due'|'overdue'|null}
 */
export function getTicketListingState(t) {
  if (isTerminalTicketStatus(t.status)) return null;

  if (isFirstResponseOverdue(t) || isResolutionOverdue(t)) {
    return 'overdue';
  }
  if (isResponseDue(t)) {
    return 'response_due';
  }
  if (hasAgentFirstResponse(t) && isLastMessageFromRequester(t)) {
    return 'requester_respond';
  }
  if (!hasAgentFirstResponse(t)) {
    return 'new';
  }
  return null;
}
